import { getUserPool, isSessionValid } from '../lib/cognitoHelper';
import { logout } from '../actions/userActions';
import { LOGOUT } from '../constants/ActionTypes';

/**
 * Custom middleware that checks if tokens are valid, and refresh the tokens or redirects to login accordingly.
 *
 */
export const tokenVerificationMiddleware = store => next => async action => {
  const state = store.getState();
  if (state.authentication && state.authentication.isAuthenticated) {
    try {
      let hasSessionBeenValidated = await isSessionValid();

      if (!hasSessionBeenValidated) {
        if (action.type != LOGOUT) {
          store.dispatch(logout());
          return; // ends the action that triggered the logout
        }
      }
    } catch (e) {
      store.dispatch(logout());
      return;
    }
  }

  next(action);
};



// WEBPACK FOOTER //
// ./middlewares/tokenVerification.js